<div class="container">
  <div class="export-buttons" *ngIf="loanSchedule.loanScheduleData.periods">
    <p>Export</p>
    <button mat-icon-button (click)="exportToExcel()" matTooltip="Excel">
       <mat-icon>description</mat-icon>
    </button>
    <button mat-icon-button (click)="exportToPDF()" matTooltip="PDF">
       <mat-icon>picture_as_pdf</mat-icon>
    </button>
  </div>

  <table id="LoanPrintPreview" mat-table [dataSource]="loanSchedule.loanScheduleData.periods" class="mat-elevation-z8">

    <ng-container matColumnDef="periodinfo">
      <th mat-header-cell *matHeaderCellDef colspan="5"></th>
     
    </ng-container>

    <ng-container matColumnDef="loanamountandbalance">
      <th mat-header-cell *matHeaderCellDef colspan="3">Cantidad y saldo del préstamo</th>
    </ng-container>


    <ng-container matColumnDef="totalcostofloan">
      <th mat-header-cell *matHeaderCellDef colspan="5">Costo total del préstamo</th>
     
    </ng-container>

    <ng-container matColumnDef="installmenttotals">
      <th mat-header-cell *matHeaderCellDef colspan="5">Cuotas totales</th>
     
    </ng-container>

    <!-- Column Group: Loan Amount and Balance -->
    <ng-container matColumnDef="period">
      <th mat-header-cell  class="center"  *matHeaderCellDef>#</th>
      <td mat-cell class="center data-cell"  *matCellDef="let period">{{ period.period }}</td>
      <td mat-footer-cell *matFooterCellDef> &nbsp; </td>
    </ng-container>

    <ng-container matColumnDef="daysInPeriod">
      <th mat-header-cell *matHeaderCellDef>Días</th>
      <td mat-cell *matCellDef="let period">{{ period.daysInPeriod }}</td>
      <td mat-footer-cell class="center" *matFooterCellDef> {{ loanSchedule.loanScheduleData.loanTermInDays }}</td>
    </ng-container>

    <ng-container matColumnDef="fromDate">
      <th mat-header-cell class="date-cell" *matHeaderCellDef>Fecha Inicio</th>
      <td mat-cell class="date-cell" *matCellDef="let period">{{ period.fromDate | dateFormat }}</td>
      <td mat-footer-cell *matFooterCellDef>  <b> Total</b></td>
    </ng-container>

    <ng-container matColumnDef="dueDate">
      <th mat-header-cell class="date-cell" *matHeaderCellDef>Fecha Fin</th>
      <td mat-cell class="date-cell" *matCellDef="let period">{{ period.dueDate | dateFormat }}</td>
      <td mat-footer-cell *matFooterCellDef> &nbsp;</td>
    </ng-container>

    <ng-container matColumnDef="obligationsMetOnDate">
      <th mat-header-cell class="date-cell" *matHeaderCellDef>Fecha de pago	</th>
      <td mat-cell class="date-cell" *matCellDef="let period">{{ period.obligationsMetOnDate | dateFormat }}</td>
      <td mat-footer-cell class="center"  *matFooterCellDef>  </td>
    </ng-container>

    <ng-container matColumnDef="complete" >
      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
      <td mat-cell class="data-cell"  *matCellDef="let period" ><i class="fa fa-check " *ngIf="period.obligationsMetOnDate"></i></td>
      <td mat-footer-cell *matFooterCellDef> &nbsp;</td>
    </ng-container>

    <!-- Second group starts here-->
    <ng-container matColumnDef="principalDue">
      <th mat-header-cell class="r-amount" *matHeaderCellDef>Deuda capital</th>
      <td mat-cell class="r-amount" class="r-amount" *matCellDef="let period" >{{ period.principalDue }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalPrincipalExpected }}</b>  </td>
    </ng-container>

    <ng-container matColumnDef="principalLoanBalanceOutstanding">
      <th mat-header-cell  class="r-amount" *matHeaderCellDef>Saldo del préstamo</th>
      <td mat-cell class="r-amount" class="r-amount" *matCellDef="let period">{{ period.principalLoanBalanceOutstanding }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> </td>
    </ng-container>

    <ng-container matColumnDef="interestOriginalDue">
      <th mat-header-cell *matHeaderCellDef>Interés</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.interestOriginalDue }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalInterestCharged }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="feeChargesDue">
      <th mat-header-cell *matHeaderCellDef>Cargos</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.feeChargesDue }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalFeeChargesCharged }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="penaltyChargesDue">
      <th mat-header-cell *matHeaderCellDef>Sanciones</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.penaltyChargesDue }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalPenaltyChargesCharged }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="totalDueForPeriod">
      <th mat-header-cell *matHeaderCellDef>Total Cuota</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.totalDueForPeriod }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalRepaymentExpected }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="totalPaidForPeriod">
      <th mat-header-cell *matHeaderCellDef>Pagado</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.totalPaidForPeriod }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalRepayment }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="totalPaidInAdvanceForPeriod">
      <th mat-header-cell *matHeaderCellDef>Por adelantado</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.totalPaidInAdvanceForPeriod }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalPaidInAdvance }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="totalPaidLateForPeriod">
      <th mat-header-cell *matHeaderCellDef>Tarde</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.totalPaidLateForPeriod }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalPaidLate }} </b> </td>
    </ng-container>

    <ng-container matColumnDef="totalOutstandingForPeriod">
      <th mat-header-cell *matHeaderCellDef>Saldo Cuota</th>
      <td mat-cell class="r-amount" *matCellDef="let period">{{ period.totalOutstandingForPeriod  }}</td>
      <td mat-footer-cell class="r-amount" *matFooterCellDef> <b> {{ loanSchedule.loanScheduleData.totalOutstanding }} </b> </td>
    </ng-container>

    <!-- Define other columns similarly -->
    <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>

</div>